<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Tipo:</label>
                        <b-form-select v-model="scaleValutazioniPazienteFilter.tipoScale" type="search" id="tipoScale" placeholder="Inserire tipo scala" :options="tipoScalaOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona Tipo Scheda - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data dal:</label>
                        <date-picker v-model="scaleValutazioniPazienteFilter.dataDal" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona data iniziale" type="date"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data al:</label>
                        <date-picker v-model="scaleValutazioniPazienteFilter.dataAl" format="DD-MM-YYYY" value-type="timestamp" placeholder="Seleziona data finale" type="date"> </date-picker>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <ras-paziente-scale-valutazione-list-component ref="cmpRasPazienteScaleValutazioneListComponent" :utente="utente" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></ras-paziente-scale-valutazione-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RasPazienteScaleValutazioneListComponent from "../components/RasPazienteScaleValutazioneListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RasPazienteScaleValutazioneListComponent,
        DatePicker,
    },
    data() {
        return {
            scaleValutazioniPazienteFilter: { tipoScale: null, dataDal: null, dataAl: null },
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/accettazioni",
            pathResourceTipoScala: "/rsascalevalutazionepaziente/tipologie",
            linkedit: null,
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            listKey: 0,
            filtroidAccettazione: { idAccettazione: null },
            tipoScalaOptions: [],
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["scaleValutazioniPazienteFilter"]) {
            me.scaleValutazioniPazienteFilter = JSON.parse(sessionStorage["scaleValutazioniPazienteFilter"]);
        }

        me.loadAccettazione();
        me.loadTipoScala();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRasPazienteScaleValutazioneListComponent.init(me.idAccettazione, me.jsonData);
                    me.showModalLoading = false;
                })
                .catch((error) => {
                    me.showModalLoading = false;
                    console.log(error);
                });
        },

        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["scaleValutazioniPazienteFilter"] = JSON.stringify(me.scaleValutazioniPazienteFilter);
            me.$refs.cmpRasPazienteScaleValutazioneListComponent.init(me.idAccettazione, me.jsonData);
        },
        onReset() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.scaleValutazioniPazienteFilter = { tipoScale: null, dataDal: null, dataAl: null };
            sessionStorage["scaleValutazioniPazienteFilter"] = JSON.stringify(me.scaleValutazioniPazienteFilter);
            me.$refs.cmpRasPazienteScaleValutazioneListComponent.init(me.idAccettazione, me.jsonData);
        },

        loadTipoScala() {
            let me = this;
            me.filtroidAccettazione = { idAccettazione: me.idAccettazione };
            UtilityMixin.methods.loadDataResources(me.pathResourceTipoScala, me.filtroidAccettazione, me.loadTipoScalaSuccess, me.loadTipoScalaError);
        },
        loadTipoScalaSuccess(response) {
            let me = this;
            me.tipoScalaOptions = [];
            if (response.data.data.length > 0) {
                me.tipoScalaOptions = response.data.data.map((item) => {
                    return { value: item.tipologia, text: item.tipologia };
                });
            }
        },
        loadTipoScalaError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento delle scale", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
